// TODO Select Player from query params by default only happens if page is refreshed

import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectChangeEvent, Box } from '@mui/material';
import { di } from '../../state/inversify.config';
import { PlayerRepository } from '../../state/reduxRepositories';
import { AccountTypes } from '../changeUser/accountTypes.enum';
import { SelectInput } from '../select/selectInput';

interface PlayerSelectionProps {
  onSelect: (value: string) => void | undefined;
  accountType?: AccountTypes;
  selectedPlayer?: string;
}
export function PlayerSelection({
  onSelect,
  accountType,
  selectedPlayer,
}: PlayerSelectionProps) {
  const { t } = useTranslation();
  const playerRepository = di.get<PlayerRepository>(PlayerRepository);
  const players = playerRepository.useResourcesSelector();

  const [player, setPlayer] = React.useState('');
  const selectPlaceholder: string = t('ID_MODULE_SELECT_PLACEHOLDER');

  const setPlayerIfAlreadySelected = () => {
    let playerExists;
    if (selectedPlayer) {
      // eslint-disable-next-line array-callback-return
      players.map((_player) => {
        if (_player.id === selectedPlayer) playerExists = _player.id;
      });
    }

    return playerExists || '';
  };

  const createPlayersList = () => {
    // TODO: break out into domain since this code is in many places
    return players.map((_player) => {
      return {
        value: _player.id,
        text: `${_player.firstName} ${_player.lastName}`,
      };
    });
  };

  const handleChange = (event: SelectChangeEvent) => {
    if (event.target.value !== selectPlaceholder) {
      onSelect(event.target.value);
    }
    setPlayer(event.target.value);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <SelectInput
        label={
          accountType === AccountTypes.Clinic
            ? t('SELECT_PATIENT').toString()
            : t('SELECT_PLAYER').toString()
        }
        value={player}
        aria-label={t('accessibility.PLAYER_SELECT')}
        name="player-select"
        items={createPlayersList()}
        onChange={handleChange}
        defaultValue={setPlayerIfAlreadySelected}
        fullWidth
        required
        tabIndex={0}
      />
    </Box>
  );
}
